








































































import {
  Component, Prop, Mixins, Watch,
} from 'vue-property-decorator';
import { State } from 'vuex-class';
import { FieldComponent, FormFieldElement } from '@/types/FieldComponent';
import { VForm } from '@/types/FormComponent';
import FieldComponentsFormData from '@/mixins/FieldComponentsFormData';
import PreviewForm from '@/components/FormBuilder/PreviewForm.vue';
import { findFieldComponent, normalizeData, normalizePreviewData } from '@/utils/form';
import LayoutMixin from '@/mixins/LayoutMixin';

@Component({
  components: { PreviewForm },
})
export default class DynamicForm extends Mixins(FieldComponentsFormData, LayoutMixin) {
  editedFields: string[] = [];

  previewData: Record<string, any> | null = null;

  @Prop({ default: 0 })
  readonly loadingItems!: number;

  @Prop({ default: false })
  readonly formDisabled!: boolean;

  @State('isModalVisible', { namespace: 'entity' })
  isModalVisible!: boolean;

  get isLoading() {
    return this.loadingItems && !this.fieldComponents.length;
  }

  get factoryForm(): VForm {
    return this.$refs.factoryForm as VForm;
  }

  get formLayoutFieldComponents(): FormFieldElement[] {
    return this.formLayoutFields
      .map((layoutElement) => findFieldComponent(layoutElement, this.fieldComponents))
      .filter((field: FormFieldElement) => field.fieldComponent?.component);
  }

  pushEditedField(fieldName: string) {
    this.editedFields.push(fieldName);
    this.$emit('edit-field');
  }

  async submit() {
    const normalizedFormData = await this.normalizeDataBeforeSubmit();

    this.$emit('submit', normalizedFormData);
  }

  togglePreview() {
    if (this.previewData) {
      this.hidePreview();
    } else {
      this.previewEntity();
    }
  }

  async previewEntity() {
    this.previewData = await this.normalizeDateBeforePreview();
    this.$bus.$emit('preview', Boolean(this.previewData));
  }

  hidePreview() {
    this.previewData = null;
    this.$bus.$emit('preview', null);
  }

  async normalizeDataBeforeSubmit() {
    const entries = this.editedFields.map((key) => {
      const valueFromFormData = this.formData[key];
      return [key, valueFromFormData];
    });
    const editedFormData = Object.fromEntries(entries);
    const normalizedData = await normalizeData(editedFormData, this.fieldComponents);
    return normalizedData;
  }

  async normalizeDateBeforePreview() {
    return normalizePreviewData(this.formData, this.fieldComponents);
  }

  @Watch('isModalVisible')
  onModalStateChange(value: boolean) {
    if (!value) {
      this.factoryForm.reset();
      this.editedFields = [];
      this.hidePreview();
    }
  }

  onChange(field: FieldComponent) {
    if (!this.editedFields.includes(field.name)) this.pushEditedField(field.name);
  }
}
